import isBot from './is-bot';

// setup data layer
window.dataLayer = window.dataLayer || [];

export const setData = (payload) => {
    payload = {
        category: undefined,
        action: undefined,
        label: undefined,
        eventIsNonInteraction: true,
        ...payload,
    };

    if (!isBot) {
        window.dataLayer.push(payload);
    }
    console.table({
        ...payload,
    });
};

export const trackEvent = (payload) => {
    setData({
        event: 'Event',
        ...payload,
    });
};

export const virtualPageView = (url) => {
    setData({
        event: 'PageView',
        url,
    });
};

export const dispatchEvent = (name, payload = {}) => {
    const event = new CustomEvent(`CookieConsent_Event`, {
        detail: {
            EventName: `CookieConsent_${name}`,
            Emitter: 'CookieConsent',
            ...payload
        }
    })

    window.dispatchEvent(event);
}
